export const styles = {
	formControl: {
		marginBottom: '16px',
		minWidth: '100%'
	},
	selectEmpty: {
		marginTop: '16px'
	},
	tooltip: {
		fontSize: '14px'
	}
};
